import FullscreenViewContainer from "./container";
import FullscreenView from "./component";
export { FullscreenView };
export default FullscreenViewContainer;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/FullscreenView/index.ts